import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "PreSeasonEntriesCard.title",
    defaultMessage: "🏃 Pre-season exercises",
  },
  empty: {
    id: "PreSeasonEntriesCard.empty",
    defaultMessage: "No pre-season exercises for today. Nice and easy!",
  },
  done: {
    id: "PreSeasonEntriesCard.done",
    defaultMessage: "Done",
  },
  notDone: {
    id: "PreSeasonEntriesCard.notDone",
    defaultMessage: "Not done",
  },
  timeMinutes: {
    id: "PreSeasonEntriesCard.timeMinutes",
    defaultMessage: "Time (minutes)",
  },
  distanceKm: {
    id: "PreSeasonEntriesCard.distanceKm",
    defaultMessage: "Distance (km)",
  },
  sets: {
    id: "PreSeasonEntriesCard.sets",
    defaultMessage: "Sets",
  },
  reps: {
    id: "PreSeasonEntriesCard.reps",
    defaultMessage: "Reps",
  },
  weightKg: {
    id: "PreSeasonEntriesCard.weightKg",
    defaultMessage: "Weight (kg)",
  },
  note: {
    id: "PreSeasonEntriesCard.note",
    defaultMessage: "Notes",
  },
  reason: {
    id: "PreSeasonEntriesCard.reason",
    defaultMessage: "Reason",
  },
  reasonOtherPlaceholder: {
    id: "PreSeasonEntriesCard.reasonOtherPlaceholder",
    defaultMessage: "Tell us more",
  },
  save: {
    id: "PreSeasonEntriesCard.save",
    defaultMessage: "Save",
  },
  saved: {
    id: "PreSeasonEntriesCard.saved",
    defaultMessage: "Saved ✓",
  },
  showHistory: {
    id: "PreSeasonEntriesCard.showHistory",
    defaultMessage: "Show recent history",
  },
  hideHistory: {
    id: "PreSeasonEntriesCard.hideHistory",
    defaultMessage: "Hide history",
  },
});
